module.exports = __webpack_public_path__ + "assets/eae447e8ff211773db659258ad5f24ec.png";